import { Component } from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {HeaderComponent} from '../../features/website/layout/header/header.component';
import {FooterComponent} from '../../features/website/layout/footer/footer.component';
import {FloatingEnquiryComponent} from '../../shared/components/floating-enquiry/floating-enquiry.component';

@Component({
  selector: 'app-website-layout.component',
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    FloatingEnquiryComponent
  ],
  templateUrl: './website-layout.component.html',
  styleUrl: './website-layout.component.scss',
})
export class WebsiteLayoutComponent {

}
